import ProductsCategoriesScreen from "@/UI/screens/ProductsCategoriesScreen";

export default function ProductsCategoriesRoute() {
    return <ProductsCategoriesScreen />;
}
